/** Keep in sync with DOCUMENT_PREVIEW_MAX_TEXT_BYTES and _MAX_OUTPUT_BYTES. */
export const TEXT_PREVIEW_LIMIT_BYTES = 1024 * 1024
export const PDF_PREVIEW_LIMIT_BYTES = 50 * 1024 * 1024
export const CSV_PREVIEW_MAX_ROWS = 200
export const CSV_PREVIEW_MAX_COLUMNS = 50
export const PREVIEW_POLL_INTERVAL_MS = 1500
export const PREVIEW_POLL_TIMEOUT_MS = 120_000
